import get from 'lodash/get'

export const mappingKeyRoomType = (roomType = []) => {
  // 空文字を除外
  return roomType.filter(x => x !== '')
}

export const mappingParamSearch = (data, menuNo) => {
  data.numPeople = data.numPeople || 1
  data.feeUpper = data.feeUpper || null
  data.feeLower = data.feeLower || null
  data.menuNo = menuNo || null
  data.searchSortBox = data.searchSortBox || 'PROPOSE'

  data.cdSearchRoomType = mappingKeyRoomType(data.roomType)
  delete data.roomType

  const mealCondition = get(data, 'mealCondition', [])
  if (mealCondition && mealCondition.length) {
    for (const item of mealCondition) {
      data[item] = true
    }
  }
  delete data.mealCondition

  const roomCondition = get(data, 'roomCondition', [])
  if (roomCondition && roomCondition.length) {
    for (const item of roomCondition) {
      data[item] = true
    }
  }
  delete data.roomCondition

  const usageMethod = get(data, 'usageMethod', [])
  if (usageMethod && usageMethod.length) {
    for (const item of usageMethod) {
      data[item] = true
    }
  }
  delete data.usageMethod
}
